import {Feature} from '@catcore/services/feature/feature';
import {Project} from '@catcore/types/api-v2';
import {JsonSchemaEntity} from '@catcore/utils/json-schema/entity-schema-to-json-schema';
import {Action} from '@ngrx/store';

export interface ActionWithPayload<T> extends Action {
  payload: T;
}

export interface ReactToState {
  feature: string;
  property: string;
}

type RouteTargetFunc = (projectId: number) => string[];

export interface ActionbarItem {
  iconType: string;
  iconSrc: string;
  label: string;
  routeTarget: RouteTargetFunc;
  isActive: boolean;
  reactToState: ReactToState;
  isApplicableForProject?: (project) => boolean;
}

export const IconType = {
  Text: 'text',
  Symbol: 'symbol',
};

export interface Message {
  severity: string;
  summary: string;
  detail: string;
  sticky: boolean;
}

export interface NotificationsState {
  messages: Message[];
}

export interface CurrentProjectState {
  project: Project;
  configStatus: string;
}

export interface CurrentFeatureState {
  created: Feature;
  deleted: Feature;
}

export interface Payload {
  project: Project;
}

export interface FeaturePayload {
  feature: Feature;
}

export interface ProjectPayload {
  project?: any;
  configStatus: string;
}

export const ProcessStatus = {
  start: 'started',
  complete: 'complete',
};

export const GenericObjectTypeInfo = {
  Null: 'null',
  Object: 'object',
  String: 'string',
  Boolean: 'boolean',
  Array: 'array',
  Number: 'number',
};

export interface ResourceList {
  totalItems: number;
  _embedded: {item: any[]};
  _links: GenericLinkedResource;

}

export interface GenericLinkedResource {
  label: string;
  href: string;
}

export interface GenericEmbeddedResourceInfo {
  name: string;
  _links: GenericSelfInfo;
}

export interface GenericResourceInfo {
  _links: GenericSelfInfo;
}

export interface GenericSelfInfo {
  self: {
    href: string;
  };
}

export interface FileBlob {
  blob: Blob;
  filename: string;
}

export interface JsonSchemaEntityRef {
  entityRef: string;
  value: JsonSchemaEntity;
}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_release@2/app/Resources/Public/src/app/modules/core/types/base.ts